export function bootstrap3MenuFixes() {

    jQuery(document).ready(function($) {
        $('.dropdown-submenu > a').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            // Toggle submenu
            $(this).next('ul').toggle();

            // Close all other submenus
            $('.dropdown-submenu > a').not(this).next('ul').hide();

            return false;
        });
    });

}